import React from 'react';
import PropTypes from 'prop-types';

import InvitationBanner from './InvitationBanner';
import DomainInvitationBanner from '../domains/DomainInvitationBanner';

export class InvitationsHeader extends React.Component {

  componentDidMount() {
    this.props.fetchInvitations();
    this.props.fetchDomainInvitations();
  }

  render() {

    let {
      invitations = [], 
      productId,
      user,
      domainInvitations
    } = this.props;

    if( productId ) {
      invitations = invitations.filter( invitation =>
        // FIXME: when an invitation was just sent, it has no attached licence...
        // we consider it to be displayable in all cases, as it is a "self sent" invitation
        // eventually, the invitation list will be reloaded and populated with the correct licence
        !invitation.licence        
        || (
          invitation.licence
          && invitation.licence.plan
          && invitation.licence.plan.product
          && invitation.licence.plan.product.id === productId
        )
      );
    }

    return (
      <React.Fragment>
        {invitations.map(invitation => 
          <InvitationBanner 
            key={invitation.id}
            user={user}
            invitation={invitation} 
          />  
        )}
        {domainInvitations.invitations.map(domainInvitation => 
          <DomainInvitationBanner
            key={domainInvitation.id}
            user={user}
            domainInvitation={domainInvitation} 
          />  
        )}
      </React.Fragment>
    );
  }
}

InvitationsHeader.propTypes = {
  // the invitations to display
  invitations: PropTypes.array,
  // optional productId to filter on
  productId: PropTypes.string,
  user: PropTypes.object.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/invitations/InvitationsHeader.js